import { IPaymentCard } from '../../store';

export function EmbossedName({ paymentCard }: { paymentCard: IPaymentCard }) {
  const name = !!paymentCard?.embossedName ? paymentCard.embossedName.toLowerCase() : '/';

  return <span className="capitalize">{name}</span>;
}
